import { PuxTypography } from "@phonero/pux-react"
import React from "react"
import { InfoBlock } from "./InfoBlock"


export const UsageTypePersonalOnlyInfoBox = ({backgroundColor}: {backgroundColor?: "none" | "light-yellow"}) => {
  return (
    <div style={{ justifySelf: "center" }}>
      <InfoBlock
        style={
          backgroundColor === "light-yellow"
            ? { backgroundColor: "#FFFCEF" }
            : {
                border: "rgba(255, 255, 255, 0.07) 2px solid",
                background: "none",
              }
        }
        color={"light-yellow"}
      >
        <PuxTypography
          variant="label"
          component="div"
          style={{ maxWidth: "600px", textAlign: "center" }}
        >
          Dette abonnementet er ikke tilknyttet en enkeltperson. SIM-kort
          endringer må utføres av bedriften.
        </PuxTypography>
      </InfoBlock>
    </div>
  )
}